import type { ImgHTMLAttributes } from "react";

export const doorwayBrandIconPaths = {
  "door-outline-forest": "/assets/doorway-icons/door-outline-forest.svg",
  "door-outline-green": "/assets/doorway-icons/door-outline-green.svg",
  "door-outline-sky": "/assets/doorway-icons/door-outline-sky.svg",
  "door-outline-white": "/assets/doorway-icons/door-outline-white.svg",
  "door-solid-green": "/assets/doorway-icons/door-solid-green.svg",
  "door-solid-indigo": "/assets/doorway-icons/door-solid-indigo.svg",
  "favicon-green": "/assets/doorway-icons/favicon-green.svg",
  "favicon-indigo": "/assets/doorway-icons/favicon-indigo.svg",
  "logo-tile-green": "/assets/doorway-icons/logo-tile-green.svg",
  "logo-tile-indigo": "/assets/doorway-icons/logo-tile-indigo.svg",
} as const;

export type DoorwayBrandIconName = keyof typeof doorwayBrandIconPaths;

type DoorwayBrandIconProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "alt" | "src"> & {
  name: DoorwayBrandIconName;
  label?: string;
};

export function DoorwayBrandIcon({ name, label, ...props }: DoorwayBrandIconProps) {
  return (
    <img
      {...props}
      src={doorwayBrandIconPaths[name]}
      alt={label ?? ""}
      aria-hidden={label ? undefined : true}
      draggable={false}
      data-doorway-icon={name}
    />
  );
}
